import { graphql, useStaticQuery } from "gatsby";
import { useI18next } from "gatsby-plugin-react-i18next";
import { MetadataWithKV } from "../types/metadata";

const MetadataQuery = graphql`
    query Metadata {
        site {
            siteMetadata {
                host: siteUrl
            }
        }
        allMarkdownRemark(
            filter: { frontmatter: { type: { eq: "metadata" } } }
        ) {
            edges {
                node {
                    id
                    fields {
                        language
                    }
                    frontmatter {
                        title
                        description
                        image {
                            publicURL
                        }
                        kv_desktop {
                            image {
                                childImageSharp {
                                    gatsbyImageData(
                                        layout: FULL_WIDTH
                                        placeholder: BLURRED
                                    )
                                }
                            }
                        }
                        kv_mobile {
                            image {
                                childImageSharp {
                                    gatsbyImageData(
                                        layout: FULL_WIDTH
                                        placeholder: BLURRED
                                    )
                                }
                            }
                        }
                        social_links {
                            platform
                            enabled
                            url
                        }
                        download_links {
                            ios
                            android
                            steam
                        }
                        boudoir_bg {
                            childImageSharp {
                                gatsbyImageData(
                                    layout: FULL_WIDTH
                                    placeholder: BLURRED
                                )
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const useMetadata = (): MetadataWithKV => {
    const metadata = useStaticQuery<Queries.MetadataQuery>(MetadataQuery);
    const { language } = useI18next();
    const { edges } = metadata.allMarkdownRemark;
    const { frontmatter } = edges.find(
        ({ node }) => node.fields?.language === language
    )!.node;

    return {
        title: frontmatter?.title,
        description: frontmatter?.description,
        image: `${metadata?.site?.siteMetadata?.host}${frontmatter?.image?.publicURL}`,
        kv_desktop: frontmatter?.kv_desktop as MetadataWithKV['kv_desktop'],
        kv_mobile: frontmatter?.kv_mobile as MetadataWithKV['kv_mobile'],
        social_links: (frontmatter?.social_links ?? []).filter((link: any) => link?.enabled && link?.url) as MetadataWithKV['social_links'],
        download_links: (frontmatter as any)?.download_links as MetadataWithKV['download_links'],
        boudoir_bg: frontmatter?.boudoir_bg as MetadataWithKV['boudoir_bg'],
    };
};
